import { render, staticRenderFns } from "./RecuperaSaldosDetalhado.vue?vue&type=template&id=db76bc4c&scoped=true&"
import script from "./RecuperaSaldosDetalhado.vue?vue&type=script&lang=js&"
export * from "./RecuperaSaldosDetalhado.vue?vue&type=script&lang=js&"
import style0 from "./RecuperaSaldosDetalhado.vue?vue&type=style&index=0&id=db76bc4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db76bc4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db76bc4c')) {
      api.createRecord('db76bc4c', component.options)
    } else {
      api.reload('db76bc4c', component.options)
    }
    module.hot.accept("./RecuperaSaldosDetalhado.vue?vue&type=template&id=db76bc4c&scoped=true&", function () {
      api.rerender('db76bc4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Materiais/RecuperaSaldosDetalhado.vue"
export default component.exports